/*
 * This file is a generated Typescript file for GRPC Gateway, DO NOT MODIFY
 */

import * as fm from "../../../fm"


/**
 * Сервис предоставляет возможность авторизации
 */

/**
 * Сервис токенов пользователей
 */
export class TokenServiceClient {
  /**
   * Конструктор сервиса
   * @param host Адрес хоста
   * @param token Токен доступа
   */
  constructor(
    public host = "",
    public token = ""
  ) { }

  /**
   * Метод получения токена по идентификатору пользователя.
   * Метод доступен для: service
   */
  PostTokenUser = (req: PostTokenUserRequestDto, init?: RequestInit): Promise<PostTokenUserResponseDto> => {
    return fm.request<PostTokenUserRequestDto, PostTokenUserResponseDto>(`${this.host}/identity/internal/api/v1/token/user/${encodeURIComponent(req.userId)}`, { ...init, method: "POST", body: JSON.stringify(req, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

}

/**
 * Запрос на получение токена по идентификатору пользователя
 */
export type PostTokenUserRequestDto = {
  /**
   * Идентификатор пользователя
   */
  userId: number
}
/**
 * Ответ на запрос на получение токена по идентификатору пользователя
 */
export type PostTokenUserResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Токен пользователя
   */
  readonly data: TokenResponseDto
  /**
   * Ошибка
   */
  readonly error: PostTokenUserResponseErrorDto
}>
/**
 * Ошибка запроса на получение токена по идентификатору пользователя
 */
export type PostTokenUserResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OptionalOneOf<{
  /**
   * Ошибка получения токена
   */
  readonly token: PostTokenUserResponseErrorTokenErrorRequestDto
}>
/**
 * Ошибка запроса на получение токена по идентификатору пользователя
 */
export type PostTokenUserResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка получения токена
   */
  readonly token: PostTokenUserResponseErrorTokenErrorDto
}>
/**
 * Ошибка получения токена.
 * Причины:
 * - Ошибка в сервисе Household
 */
export type PostTokenUserResponseErrorTokenErrorRequestDto = {
}
/**
 * Ошибка получения токена.
 * Причины:
 * - Ошибка в сервисе Household
 */
export type PostTokenUserResponseErrorTokenErrorDto = {
}
/**
 * Информация о токене доступа пользователя
 */
export type TokenRequestDto = {
  /**
   * Токен
   */
  accessToken: string
  /**
   * Время (в секундах), через которое истечет срок действия Access Token
   */
  expiresIn: number
}
/**
 * Информация о токене доступа пользователя
 */
export type TokenResponseDto = {
  /**
   * Токен
   */
  accessToken: string
  /**
   * Время (в секундах), через которое истечет срок действия Access Token
   */
  expiresIn: number
}
/**
 * Дескриптор
 */
export const descriptor = {
  /**
   * Запрос на получение токена по идентификатору пользователя
   */
  "PostTokenUserRequest": {
    "kind": "class",
    "text": "Запрос на получение токена по идентификатору пользователя",
    "fields": {
      /**
       * Идентификатор пользователя
       */
      "userId": {
        "type": "int32",
        "text": "Идентификатор пользователя",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос на получение токена по идентификатору пользователя
   */
  "PostTokenUserResponse": {
    "kind": "class",
    "text": "Ответ на запрос на получение токена по идентификатору пользователя",
    "fields": {
      /**
       * Токен пользователя
       */
      "data": {
        "type": "Token",
        "text": "Токен пользователя",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "PostTokenUserResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса на получение токена по идентификатору пользователя
   */
  "PostTokenUserResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса на получение токена по идентификатору пользователя",
    "fields": {
      /**
       * Ошибка получения токена
       */
      "token": {
        "type": "PostTokenUserResponse.Error.TokenError",
        "text": "Ошибка получения токена",
      },
    },
  },
  /**
   * Ошибка получения токена.
   * Причины:
   * - Ошибка в сервисе Household
   */
  "PostTokenUserResponse.Error.TokenError": {
    "kind": "class",
    "text": "Ошибка получения токена.\nПричины:\n- Ошибка в сервисе Household",
  },
  /**
   * Информация о токене доступа пользователя
   */
  "Token": {
    "kind": "class",
    "text": "Информация о токене доступа пользователя",
    "fields": {
      /**
       * Токен
       */
      "accessToken": {
        "type": "string",
        "text": "Токен",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Время (в секундах), через которое истечет срок действия Access Token
       */
      "expiresIn": {
        "type": "int32",
        "text": "Время (в секундах), через которое истечет срок действия Access Token",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
}